import { ANALYTIC_EVENTS } from "@/const/event.constants"
import { HowToFixCard } from "@/molecules/HowToFixCard"
import { useCopyable } from "@/organisms/Drawers/components/TriageDrawer/hooks/useCopyable"
import { RemediationGuide } from "./RemediationGuide"

import type { InnerCardProps } from "../../PackageVulnerabilityCards.types"

import styles from "./RemediationCard.module.scss"

export const RemediationCard = (props: InnerCardProps) => {
  const { t, response } = props
  const { issue: record } = response || {}
  const onCopy = useCopyable("copyable-remediation-guide", record?.issueType, {
    mixpanelEvent: ANALYTIC_EVENTS.TRIAGE.DRAWER.COPY_HOW_TO_FIX
  })

  if (!record) return null

  const { id, fixInsights } = record

  return (
    <HowToFixCard t={t} onCopy={onCopy}>
      <RemediationGuide
        id={id}
        remediationEffort={fixInsights?.remediationEffort}
        hasFixVersion={!!fixInsights?.hasFixVersion}
        {...props}
      />

      <span
        id="copyable-remediation-guide"
        className={styles.copyableContainer}
      >
        <span data-element-issue-expandable-cell-view="fix-container">
          <RemediationGuide
            copyable
            id={id}
            remediationEffort={fixInsights?.remediationEffort}
            hasFixVersion={!!fixInsights?.hasFixVersion}
            {...props}
          />
        </span>
      </span>
    </HowToFixCard>
  )
}
